import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import Select from "react-select";
import { useForm } from 'react-hook-form';
import CustomerContext from "../../context/otogas/customers/customersContext";

const FileUploader = ({ uploadFunction, name, allowed_file_types }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const customerContext = useContext(CustomerContext);
  const { listTopupPaymentTypes, topup_payment_types } = customerContext;

  useEffect(() => {
    listTopupPaymentTypes();
  }, []); 

  // Initialize react-hook-form
  const { register, setValue, getValues, formState: { errors } } = useForm();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };


  const handleUpload = async () => {
    const paymentType = getValues("paymentType");
    if (!file) {
      alert('Please select a file first.');
      return;
    }
    if (!paymentType) {
      alert('Please select a payment type.');
      return;
    }
    setLoading(true);
    try {
      // Pass both file and paymentType to the upload function
      await uploadFunction(file, paymentType);
    } catch (error) {
      // Handle error (e.g., display an error message)
    } finally {
      setLoading(false);
      setShowModal(false); // Close modal after upload
    }
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <button className="btn btn-secondary m-1" onClick={openModal}>
        {name}
      </button>

      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Select a file to upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="paymentType" className="mt-3">
            <Form.Label>Select Payment Type</Form.Label>
            <Select
              options={topup_payment_types.map((type) => ({
                value: type.topUpTypeId,
                label: type.topUpTypeName.replace(/_/g, " "),
              }))}
              onChange={(selectedOption) => {
                setValue("paymentType", selectedOption.value); // Update form value
              }}
              placeholder="Select Payment Type"
            />
            {errors.paymentType && (
              <Form.Control.Feedback type="invalid">
                {errors.paymentType.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Control
              type="file"
              onChange={handleFileChange}
              accept={allowed_file_types.join(',')}
            />
          </Form.Group>
          <small>Allowed file types: {allowed_file_types.join(', ')}</small>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpload} disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{' '}
                Uploading...
              </>
            ) : (
              'Upload'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FileUploader;
